import React from "react";
import { IconButton, PrimaryButton, TeachingBubble } from "@fluentui/react";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";
import { launchRefreshElaboration } from "../../../utils/helpers/ElaborationHelper";
import { CoObjectItem } from "../../interfaces/CoObject";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { ObjectsListUpdateFooterState, useObjectsListUpdateFooter } from "./ObjectsListUpdateFooterHook";
import { DocumentPart } from "../../../api/models";
import { DocumentPartMetadata } from "../../../api/models/document-part-metadata";

interface ObjectsListUpdateFooterProps {
  selectedObjects: Map<string, CoObjectItem>;
  username: string;
  documentPart: DocumentPart;
  documentPartMetadata: DocumentPartMetadata;
}

export const ObjectsListUpdateFooter: React.FC<ObjectsListUpdateFooterProps> = (props) => {
  const { selectedObjects, username, documentPart, documentPartMetadata } = props;
  const { state, setTableUpdateType, tableUpdateOptions, splitUpdateButton, toggleTeachingBubble } =
    useObjectsListUpdateFooter(selectedObjects);

  return (
    <>
      {state.teachingBubbleVisible && (
        <TeachingBubble
          calloutProps={{ calloutWidth: 300, backgroundColor: "lightgray" }}
          hasCloseButton={true}
          target={`#ObjectsListPageInfoId`}
          closeButtonAriaLabel="Close"
          onDismiss={toggleTeachingBubble}
          headline={formatMessage("cof.documentpartupdate.teachingbubble.headline")}
        >
          <ul>
            <li>
              <b>{formatMessage("cof.base.update")}</b>:
              {formatMessage("cof.objectlistupdate.teachingbubble.update.description")}
            </li>
            <li>
              <b>{formatMessage("cof.updates.fullreset")}</b>:
              {formatMessage("cof.objectlistupdate.teachingbubble.fullreset.description")}
            </li>
            <li>
              <b>{formatMessage("cof.updates.keepallchanges")}</b>:
              {formatMessage("cof.objectlistupdate.teachingbubble.keepallchanges.description")}
            </li>
          </ul>
        </TeachingBubble>
      )}
      <PrimaryButton
        id="update_button"
        disabled={selectedObjects.size === 0}
        className={ButtonVariants.primary}
        styles={{
          label: { whiteSpace: "nowrap" },
          root: { float: "right" },
          splitButtonContainer: { float: "right" },
        }}
        onClick={() =>
          launchRefreshElaboration(
            username,
            Array.from(selectedObjects.values()),
            documentPart,
            documentPartMetadata,
            undefined,
            state.tableUpdateType
          )
        }
        text={tableUpdateOptions.find((opt) => state.tableUpdateType === opt.key)?.text}
        split={splitUpdateButton(selectedObjects)}
        menuProps={
          splitUpdateButton(selectedObjects) && {
            items: tableUpdateOptions,
            isBeakVisible: false,
            onItemClick: (_, opt) => setTableUpdateType(opt.key as ObjectsListUpdateFooterState["tableUpdateType"]),
          }
        }
      />
      <IconButton
        id="ObjectsListPageInfoId"
        hidden={!splitUpdateButton(selectedObjects)}
        aria-label="Info"
        iconProps={{ iconName: "InfoSolid", style: { fontSize: "larger" } }}
        styles={{
          label: { whiteSpace: "nowrap" },
          root: { float: "right" },
          splitButtonContainer: { float: "right" },
        }}
        disabled={selectedObjects.size === 0}
        onClick={toggleTeachingBubble}
      />
    </>
  );
};
